import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { Button, Subtitle } from "uikit/components";
import { useFrontendAppVersion } from "hooks/useFrontendAppVersion";
import { useContextPerson } from "hooks/persons";

export function useAppVersionMismatchNotification() {
    const { appVersion: backendVersion, isLoading } = useContextPerson();
    const frontendVersion = useFrontendAppVersion();

    const versionMismatch = !isLoading && backendVersion !== frontendVersion;

    const toastId = React.useRef(null);

    const notify = () =>
        (toastId.current = toast.warning(
            <>
                <Subtitle size={"subtitle-1"}>Доступна новая версия приложения</Subtitle>
                <p>Необходимо обновить страницу во избежание некорректной работы системы.</p>
                <Button onClick={() => window.location.reload()} outline size={"small"}>
                    Обновить страницу
                </Button>
            </>,
            {
                position: "top-right",
                toastId: "app_version_mismatch_toast",
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                closeButton: null,
                progress: undefined,
            },
        ));

    const dismiss = () => {
        let currentToastId = toastId.current;
        if (currentToastId) {
            toast.dismiss(toastId.current);
        }
        toastId.current = null;
    };

    useEffect(() => {
        if (versionMismatch) {
            notify();
        } else {
            dismiss();
        }
    }, [versionMismatch]);
}
